import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OfferNotification } from 'src/app/_helpers/endpoints';
import { HttpRequestApi } from 'src/app/_helpers/http-request';
import { OfertaLaboral } from './models/oferta-laboral';

@Injectable({
  providedIn: 'root'
})
export class OfertasDeTrabajoService {

  constructor(private http: HttpClient) { }


  offerList(estatus: number): Observable<OfertaLaboral[]> {
    return this.http
    .get<OfertaLaboral[]>
    (HttpRequestApi.getUrlApi(OfferNotification.OFFER_LIST.replace('{estado}',estatus.toString())));
  }

}
